import React from 'react';
import { FormattedMessage } from 'react-intl';
import Spacing from 'tidee-life-ui/dist/src/spacing.js';
import { Text } from 'tidee-life-ui/dist/src/typography.js';
import TemplateA from '../templates/template-a.tsx';
import messages from '../../i18n/src/messages.ts';

const Error404: React.FC = () => {
    return (
        <TemplateA>
            <Spacing
                align="center"
                width="100%"
                padding={['lg', null, null, null]}
            >
                <Text align="center" size="lg">
                    <FormattedMessage {...messages['error.404.msg']} />
                </Text>
            </Spacing>
        </TemplateA>
    );
};

export default Error404;
